import { createSlice } from '@reduxjs/toolkit'
import { printLogs } from '../../utils';
import {
    addBusinessAction,
    addBusinessAddressAction,
    addBusinessContactAction,
    addBusinessTypesAction,
    addCommunityTypesAction,
    addMailingTypesAction,
    addSubscriptionToBusinessContactAction,
    deactiveAddressesAction,
    deactiveBusinessesAction,
    deactiveContactsAction,
    delBusinessAddressAction,
    delBusinessContactAction,
    deleteBusinessTypesAction,
    deleteCommunityTypesAction,
    deleteMailingTypesAction,
    editBusinessTypesAction,
    editCommunityTypesAction,
    editMailingTypesAction,
    getBusinessAddressesAction,
    getBusinessByIdAction,
    getBusinessContactSubscriptionsAction,
    getBusinessContactsAction,
    getBusinessCountSubscriptionsAction,
    getBusinessTypeBasedSearchAction,
    getBusinessTypesAction,
    getBusinessesByMailingTypeIdAction,
    getBusinessesListAction,
    getBusinessesListViaContactsAction,
    getCommunityCountSubscriptionsAction,
    getCommunityTypeBasedSearchAction,
    getCommunityTypesAction,
    getEOCertifiedCountSubscriptionsAction,
    getEOCertifiedSearchAction,
    getFloodGroupsBasedSearchAction,
    getFloodGroupsCountSubscriptionsAction,
    getGroupsByBusinessIdAction,
    getMailingCountSubscriptionsAction,
    getMailingTypeBasedSearchAction,
    getMailingTypesAction,
    purgeAddressesAction,
    purgeBusinessesAction,
    purgeContactsAction,
    removeSubscriptionFromBusinessContactAction,
    searchAction,
    searchEndsWithAction,
    searchStartsWithAction,
    updateBusinessAddressAction,
    updateBusinessContactAction,
    updateBusinessDetailsAction
} from '../actions/businessesAction';

export const businessSlice = createSlice({
    name: 'businesses',
    initialState: {
        status: 'idle',
        error: "",
        businessesList: [],
        selectedBusiness: {},
        businessTypes: [],
        communityTypes: [],
        mailingTypes: [],
        businessAddresses: [],
        businessContacts: [],
        businessContactSubscriptions: []
    },
    reducers: {
        setSelectedBusiness: (state, action) => {
            return {
                ...state,
                selectedBusiness: action.payload
            }
        }
    },
    extraReducers(builder) {
        // Fetch All Master Bid Items 
        builder
            .addCase(getBusinessesListAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessesListAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                let tempBusinessList = state.businessesList;
                state.businessesList = [...tempBusinessList, action.payload.data];
            })
            .addCase(getBusinessesListAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getBusinessTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.businessTypes = action.payload.data;
            })
            .addCase(getBusinessTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(addBusinessTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(addBusinessTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(addBusinessTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to add"
            })

            .addCase(editBusinessTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(editBusinessTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(editBusinessTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to update"
            })

            .addCase(deleteBusinessTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(deleteBusinessTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(deleteBusinessTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to delete"
            })


            .addCase(getCommunityTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getCommunityTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.communityTypes = action.payload.data;
            })
            .addCase(getCommunityTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })


            .addCase(addCommunityTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(addCommunityTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(addCommunityTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to add"
            })

            .addCase(editCommunityTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(editCommunityTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(editCommunityTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to update"
            })

            .addCase(deleteCommunityTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(deleteCommunityTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(deleteCommunityTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to delete"
            })

            .addCase(getMailingTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getMailingTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(getMailingTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(addMailingTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(addMailingTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(addMailingTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to add"
            })

            .addCase(editMailingTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(editMailingTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(editMailingTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to update"
            })

            .addCase(deleteMailingTypesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(deleteMailingTypesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.mailingTypes = action.payload.data;
            })
            .addCase(deleteMailingTypesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to delete"
            })


            .addCase(getBusinessAddressesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessAddressesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.businessAddresses = action.payload.data;
            })
            .addCase(getBusinessAddressesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getBusinessContactsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessContactsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.businessContacts = action.payload.data;
            })
            .addCase(getBusinessContactsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getBusinessContactSubscriptionsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessContactSubscriptionsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.businessContactSubscriptions = action.payload.data;
            })
            .addCase(getBusinessContactSubscriptionsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(addSubscriptionToBusinessContactAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(addSubscriptionToBusinessContactAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(addSubscriptionToBusinessContactAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(removeSubscriptionFromBusinessContactAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(removeSubscriptionFromBusinessContactAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(removeSubscriptionFromBusinessContactAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(updateBusinessDetailsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(updateBusinessDetailsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(updateBusinessDetailsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to update"
            })

            .addCase(addBusinessAddressAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(addBusinessAddressAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(addBusinessAddressAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to add"
            })

            .addCase(updateBusinessAddressAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(updateBusinessAddressAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(updateBusinessAddressAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to update"
            })

            .addCase(delBusinessAddressAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(delBusinessAddressAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(delBusinessAddressAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to delete"
            })

            .addCase(addBusinessContactAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(addBusinessContactAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(addBusinessContactAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to add"
            })

            .addCase(updateBusinessContactAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(updateBusinessContactAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(updateBusinessContactAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to update"
            })

            .addCase(delBusinessContactAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(delBusinessContactAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(delBusinessContactAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to delete"
            })

            .addCase(getBusinessesListViaContactsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessesListViaContactsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getBusinessesListViaContactsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(searchAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(searchAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(searchAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(searchStartsWithAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(searchStartsWithAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(searchStartsWithAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(searchEndsWithAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(searchEndsWithAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(searchEndsWithAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(addBusinessAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(addBusinessAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(addBusinessAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to add"
            })

            .addCase(getBusinessCountSubscriptionsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessCountSubscriptionsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getBusinessCountSubscriptionsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getMailingCountSubscriptionsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getMailingCountSubscriptionsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getMailingCountSubscriptionsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getCommunityCountSubscriptionsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getCommunityCountSubscriptionsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getCommunityCountSubscriptionsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getEOCertifiedCountSubscriptionsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getEOCertifiedCountSubscriptionsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getEOCertifiedCountSubscriptionsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getFloodGroupsCountSubscriptionsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getFloodGroupsCountSubscriptionsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getFloodGroupsCountSubscriptionsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getMailingTypeBasedSearchAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getMailingTypeBasedSearchAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getMailingTypeBasedSearchAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getBusinessTypeBasedSearchAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessTypeBasedSearchAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getBusinessTypeBasedSearchAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getCommunityTypeBasedSearchAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getCommunityTypeBasedSearchAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getCommunityTypeBasedSearchAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getEOCertifiedSearchAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getEOCertifiedSearchAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getEOCertifiedSearchAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getFloodGroupsBasedSearchAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getFloodGroupsBasedSearchAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getFloodGroupsBasedSearchAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getBusinessesByMailingTypeIdAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessesByMailingTypeIdAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getBusinessesByMailingTypeIdAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getGroupsByBusinessIdAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getGroupsByBusinessIdAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getGroupsByBusinessIdAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(getBusinessByIdAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(getBusinessByIdAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(getBusinessByIdAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })

            .addCase(deactiveContactsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(deactiveContactsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(deactiveContactsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to deactivate"
            })

            .addCase(purgeContactsAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(purgeContactsAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(purgeContactsAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to purge"
            })

            .addCase(deactiveAddressesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(deactiveAddressesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(deactiveAddressesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to deactivate"
            })

            .addCase(purgeAddressesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(purgeAddressesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(purgeAddressesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to purge"
            })
            
            .addCase(deactiveBusinessesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(deactiveBusinessesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(deactiveBusinessesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to deactivate"
            })

            .addCase(purgeBusinessesAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(purgeBusinessesAction.fulfilled, (state, action) => {
                state.status = "succeeded"
            })
            .addCase(purgeBusinessesAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to purge"
            })
    }
})

export const {
    setSelectedBusiness,
} = businessSlice.actions

export default businessSlice.reducer